import {ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {appRoutes} from './app.routes';
import {ENV_TOKEN, environmentCurrent} from 'env-config';
import {ConfigService} from './services/config.service';
import {authRefreshInterceptor, AuthService, ExternalRedirect} from 'auth';
import {EXTERNAL_REDIRECT} from 'products-lib';
import {CookieConsentServiceImpl} from '../services/CookieConsentServiceImpl';
import {CookieConsentService} from '../services/cookie-consent.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      appRoutes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
        onSameUrlNavigation: 'reload'
      })
    ),
    provideHttpClient(withInterceptors([authRefreshInterceptor])),
    {provide: ENV_TOKEN, useValue: environmentCurrent},
    {provide: EXTERNAL_REDIRECT, useClass: ExternalRedirect},
    provideAppInitializer(() => {
      inject(ConfigService).loadGApiScript();
    }),
    provideAppInitializer(() => {
      // Deliberately not awaited: an inbound SSO handoff can wait for provisioning, and the waiting
      // page must render meanwhile. bootstrapAuth moves the URL to that page synchronously, before
      // the router's initial navigation, so guards never race the exchange.
      inject(AuthService).bootstrapAuth().then(() => {
      });
    }),
    { provide: CookieConsentService, useClass: CookieConsentServiceImpl },
  ]
};
